import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { Grid, LinearProgress, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DataGrid, GridOverlay } from '@mui/x-data-grid';
import AiTrainingDataContext from '../../AiTrainingDataContext';
import TranscriptionData from '../Library/TranscriptionData';
import OrderSummaryComparision from './OrderSummaryComparision';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiDataGrid-columnHeaderTitleContainer': {
            padding: 0,
            margin: 0,
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            overflow: 'none',
        },
        '& .MuiDataGrid-iconButtonContainer': {
            padding: 0,
            margin: 0,
        },
        '& .MuiIconButton-root': {
            padding: 0,
            margin: 0,
        },
    },
}));

function CustomLoadingOverlay() {
    return (
        <GridOverlay>
            <div style={{ position: 'absolute', top: 0, width: '100%' }}>
                <LinearProgress />
            </div>
        </GridOverlay>
    );
}

function SimulationJobDetailedStats() {
    const classes = useStyles();
    const [pageSize, setPageSize] = useState(5);
    const rowHeight = 175;
    const location = useLocation();

    const {
        simulationJobDetailedStats,
        simDetailedStatsLoading,
        setSimDetailedStatsLoading,
        fetchSumilationJobDetailedStats,
        selectedSimJob,
        restauId,
    } = useContext(AiTrainingDataContext);

    const columns = [
        {
            field: 'id',
            // type: 'string',
            headerName: 'Recording Id',
            flex: 0.2,
            headerAlign: 'center',
            align: 'center',
            // renderCell: (params) => (
            //     <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
            //         <Typography>{params.row.id}</Typography>
            //     </Box>
            // ),
        },
        {
            field: 'audioUrl',
            // type: 'string',
            headerName: 'Audio File',
            flex: 0.3,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <audio controls style={{ width: '100%' }}>
                    <source src={params.row.audioUrl} type="audio/mpeg" />
                    Your browser does not support the audio element.
                </audio>
            ),
        },
        {
            field: 'callDuration',
            type: 'number',
            headerName: 'Call Duration',
            flex: 0.15,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'transcriptByCrowd',
            // type: 'string',
            headerName: 'Transcription',
            flex: 0.5,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <TranscriptionData
                    rowId={params.row.id}
                    transcriptionData={params.row.transcriptByCrowd || []}
                    allowEdits={false}
                />
            ),
        },
        {
            field: 'orderSummary',
            // type: 'string',
            headerName: 'Order Summary',
            flex: 0.5,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <OrderSummaryComparision
                    itemMappingDetails={params.row.itemMappingDetails}
                    orderSummaryByCrowd={params.row.orderSummaryByCrowd}
                    orderSummaryByAI={params.row.orderSummaryByAI}
                    error={params.row.error}
                />
            ),
        },
    ];

    const loadData = async (jobId) => {
        setSimDetailedStatsLoading(true);
        await fetchSumilationJobDetailedStats(jobId);
        setSimDetailedStatsLoading(false);
    };

    useEffect(() => {
        //debugger;
        let jobId = '';
        if (location.pathname.includes('simulationResults/')) {
            jobId = location.pathname.split('/').slice(-1)[0];
        }
        if (!jobId) return;
        // Fetch data and set loading state
        loadData(jobId);
    }, [restauId]);

    return (
        <>
            <Grid
                container
                //columnSpacing={1}
                item
                xs={12}
                //justifyContent={'center'}
                justifyContent="flex-start" // or "space-between"
                sx={{ m: 2 }}
            >
                <Grid item xs={1}>
                    <Link
                        sx={{ margin: 0 }}
                        to={`/aitrainingData/simulationResults`}
                    >
                        {'<< back'}
                    </Link>
                </Grid>
                <Grid item xs={3.5}>
                    <Typography variant="h6" sx={{ fontSize: '1.1rem' }}>
                        JobId: {selectedSimJob && selectedSimJob.jobId}
                    </Typography>
                </Grid>
                <Grid item xs={2.5}>
                    <Typography variant="h6" sx={{ fontSize: '1.1rem' }}>
                        Status: {selectedSimJob && selectedSimJob.status}
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="h6" sx={{ fontSize: '1.1rem' }}>
                        OrderErrorRate:{' '}
                        {selectedSimJob && selectedSimJob.orderErrorRate}
                    </Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="h6" sx={{ fontSize: '1.1rem' }}>
                        ItemErrorRate:{' '}
                        {selectedSimJob && selectedSimJob.itemErrorRate}
                    </Typography>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <DataGrid
                    className={classes.root}
                    rows={simulationJobDetailedStats}
                    columns={columns}
                    autoHeight={true}
                    loading={simDetailedStatsLoading}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[5, 10, 15, 20, 50]}
                    pagination
                    components={{
                        LoadingOverlay: CustomLoadingOverlay,
                    }}
                    rowHeight={rowHeight}
                />
            </Grid>
        </>
    );
}

SimulationJobDetailedStats.propTypes = {
    test: PropTypes.string,
};

export default SimulationJobDetailedStats;
